export const NAME = 'banner';

// Banner state
export const SHOW_BANNER = 'SHOW_BANNER';
export const HIDE_BANNER = 'HIDE_BANNER';

// Banner type
export const BANNER_TYPE_COOKIE = 'BANNER_TYPE_COOKIE';



// WEBPACK FOOTER //
// ./src/services/banner/constants.js